{
  "allItems": "Alle Durchläufe",
  "chunkState": {
    "empty": "keine Annotationen",
    "failed": "fehlgeschlagen",
    "proposed": "vorgeschlagen",
    "proposing": "wird vorgeschlagen"
  },
  "chunk_one": "Änderungssatz {{number}} ({{count}} Durchlauf)",
  "chunk_other": "Änderungssatz {{number}} ({{count}} Durchläufe)",
  "chunks": "Änderungssätze zum Review",
  "column": {
    "attempt": "Versuch",
    "state": "Zustand",
    "unit": "Dokument oder Segment",
    "usage": "Verbraucht"
  },
  "complete": "Vollständig",
  "concurrencyInForce_one": "{{count}} gleichzeitig",
  "concurrencyInForce_other": "{{count}} gleichzeitig",
  "connectorOffline": "DMW Connector offline",
  "connectorOnline": "DMW Connector online",
  "control": {
    "cancel": "Stapelverarbeitung abbrechen",
    "pause": "Pausieren",
    "resume": "Fortsetzen",
    "start": "Starten"
  },
  "corpusVersion": "Korpusversion",
  "costSoFar": "Bisher verbraucht",
  "dependsOn": "Abhängig von",
  "eta": "Restzeit",
  "filter": "Durchläufe zeigen",
  "held": "wartet: der Anbieter bittet um Pause, oder das Budget der LLM-Route ist aufgebraucht",
  "heldUntil": "bis {{time}}",
  "humanSteps": {
    "queue": "In jedem Durchlauf auf eine Person warten",
    "skip": "Überspringen: Review am Ende"
  },
  "itemState": {
    "cancelled": "Abgebrochen",
    "done": "Fertig",
    "failed": "Fehlgeschlagen",
    "pending": "Wartet",
    "running": "Läuft",
    "waiting_for_human": "Wartet auf eine Person"
  },
  "items": "Durchläufe",
  "list": {
    "progress_one": "{{done}} fertig, {{failed}} fehlgeschlagen, von {{count}}",
    "progress_other": "{{done}} fertig, {{failed}} fehlgeschlagen, von {{count}}",
    "title": "Stapelverarbeitungen"
  },
  "missingUnits": "Fehlende Einheiten",
  "nextPage": "Weiter",
  "ofTotal_one": "von {{count}} Durchlauf",
  "ofTotal_other": "von {{count}} Durchläufen",
  "openThread": "Durchlauf",
  "partial": "Unvollständig",
  "pauseReason": {
    "connector_offline": "der DMW Connector ist offline",
    "item_withdrawn": "ein Element, das das Prozessschema verwendet, wurde zurückgezogen; kein weiterer Durchlauf kann starten",
    "repeated_failures": "mehrere Durchläufe in Folge fehlgeschlagen; erst nachsehen, dann weiter",
    "requested": "von Ihnen pausiert",
    "route_blocked": "Schlüssel oder Guthaben der LLM-Route wurde abgelehnt"
  },
  "planUnits": "Planeinheiten",
  "previousPage": "Zurück",
  "retry": "Erneut versuchen",
  "review": "Review",
  "setConcurrency": "Setzen",
  "start": {
    "batchTitle": "Titel",
    "changeSets": "Vorschläge",
    "chosenDocuments": "Ausgewählte Dokumente (nach Schlüssel)",
    "chunkSize": "Durchläufe pro Änderungssatz",
    "chunked": "Änderungssätze zu je N Durchläufen",
    "concurrency": "Gleichzeitig",
    "concurrencyDefault": "so viele der DMW Connector erlaubt",
    "connectorHint": "Jeder LLM-Aufruf läuft auf Ihrem DMW Connector. Geht er offline, pausiert die Stapelverarbeitung und setzt fort, sobald er zurück ist; fertige Aufrufe werden nie wiederholt.",
    "documents": "Welche Dokumente",
    "field": "Feld",
    "humanSteps": "Schritte, die eine Person brauchen",
    "keysPlaceholder": "Ein Dokumentschlüssel pro Zeile",
    "many": "viele Dokumente",
    "metadata": "Dokumente mit einem Metadatenwert",
    "open": "Auf viele Dokumente anwenden",
    "perItem": "Ein Änderungssatz pro Durchlauf",
    "preview": "Zeigen, worauf sie läuft",
    "problem": {
      "noDocuments": "Nenne mindestens einen Dokumentschlüssel.",
      "noMetadata": "Nenne ein Metadatenfeld und seinen Wert.",
      "segmentType": "Ein Segmenttyp besteht aus Kleinbuchstaben, Ziffern und Unterstrichen."
    },
    "route": "LLM-Route",
    "routeHint": "Ein API-Schlüssel hat ein eigenes, abgerechnetes Kontingent; ein Abo-Agent teilt Ihre persönlichen Limits. Beide laufen auf Ihrem DMW Connector.",
    "segmentType": "Nur Segmente dieses Typs (optional)",
    "segmentTypePlaceholder": "zum Beispiel scene",
    "starting": "Wird gestartet…",
    "submit": "Stapelverarbeitung starten",
    "subtitle": "Ein Durchlauf pro Dokument oder Segment, mit Prozessschema, LLM-Route und Profil dieses Durchlaufs, auf Ihrem DMW Connector.",
    "title": "Dieses Prozessschema auf viele Dokumente anwenden",
    "units_one": "{{count}} Durchlauf",
    "units_other": "{{count}} Durchläufe",
    "value": "Wert",
    "wholeCorpus": "Die ganze Korpusversion"
  },
  "state": {
    "cancelled": "Abgebrochen",
    "completed": "Abgeschlossen",
    "failed": "Mit Fehlern beendet",
    "paused": "Pausiert",
    "planned": "Geplant",
    "running": "Läuft"
  },
  "statementParts": "Teilergebnisse",
  "unknown": "noch nicht bekannt",
  "unplannable": "Nicht planbar",
  "vitaAssemblies": "Zusammengeführte Vitae",
  "vitaNotFound": "Diese Vita-Zusammenstellung ist nicht verfügbar.",
  "workflow": "Prozessschema"
}
